<template>
  <div class="main-table">
    <div class="">
      <div class="d-flex justify-space-between align-center total-data">
        <v-switch
          v-model="compactView"
          dense
          flat
          inset
          class="mr-10"
          @change="onPrChange"
          label="Compact View"
        ></v-switch>
        <div style="max-width: 155px" v-if="ShowAge">
          <v-select
            :items="listUmur"
            item-text="Title"
            item-value="Id"
            label="Umur"
            solo
            dense
            hide-details="auto"
            @change="onAgeChange"
            v-model="ageGroup"
          >
            <template slot="item" slot-scope="data" title="Salasaan Race">
              {{ data.item.Title }}
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="sticky-info-table text--secondary d-flex justify-space-between">
      <div>{{ AgeGroupDisplay }} {{ FilteredList.length }} Total</div>
      <div>Last update : {{ LastUpdatedDetail }}</div>
    </div>
    <v-card elevation="2" rounded="lg" v-if="Athletes.length > 0">
      <v-simple-table dense v-if="FilteredList.length > 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center pr-0 pl-2" style="width: 35px">Rank</th>
              <th class="pa-0" style="width: 1px" v-if="!compactView"></th>
              <th class="text-left">Athlete</th>
              <th class="text-right pl-0" style="width: 63px">Speed</th>
              <th class="text-right" style="width: 95px; padding-right: 20px">
                Time
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
              <td style="height: 30px">
                <v-skeleton-loader
                  type="avatar"
                  max-height="30px"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  type="avatar"
                  width="32"
                  height="32"
                ></v-skeleton-loader>
              </td>
            </tr> -->
            <tr v-for="(item, index) in FilteredList" :key="item.ProfileUrl">
              <td class="text-center pr-0 pl-2">{{ index + 1 }}</td>
              <td class="pr-0 py-2" v-if="!compactView">
                <v-avatar size="30">
                  <img :src="item.ImageUrl | useEmpty" />
                </v-avatar>
              </td>
              <td class="pr-1 name-col">
                <div class="name-container">
                  <div class="name-truncated">
                    <a
                      class="link"
                      @click="onProfileClick(item)"
                      :href="'https://www.strava.com/athletes/' + item.Id"
                      target="_blank"
                      >{{ item.Name }}</a
                    >
                    <div
                      class="text--secondary text-small text-truncate"
                      v-if="!compactView"
                    >
                      <a
                        class="link text--secondary"
                        :href="
                          'https://www.strava.com/segment_efforts/' +
                          item.PrActivityId
                        "
                        :title="item.PrDate"
                        target="_blank"
                        v-if="item.Pr != null"
                        @click="onPrActivityClick(item)"
                        >{{ item.Pr }}
                        <span> • </span>
                        <span> {{ item.PrDate | relativeDateView }}</span>
                      </a>
                      <div v-else>-</div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="text-right px-0">
                {{ item.Speed }} <span class="text-mini-muted">km/h</span>
              </td>
              <td class="pl-0">
                <div class="time-with-pr">
                  <div class="icon-pr1" v-if="item.IsNewPr"></div>
                  <a
                    class="link"
                    :href="
                      'https://www.strava.com/segment_efforts/' +
                      item.ActivityId
                    "
                    target="_blank"
                    @click="onActivityClick(item)"
                    >{{ item.Time }}</a
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div
        v-if="
          search &&
          search.length > 0 &&
          Athletes.length > 0 &&
          FilteredList.length == 0
        "
        style="padding: 20px; text-align: center"
      >
        Data tidak ditemukan
      </div>
    </v-card>
    <div
      class="text-center text-caption py-5"
      @click="$vuetify.goTo(0)"
      style="cursor: pointer"
    >
      <div>Back to top</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      Leaderboard: null,
      compactView: false,
      search: "",
      date: "",
      ageGroup: "ALL",
      listUmur: [
        {
          Title: "All",
          Id: "ALL",
        },
        {
          Title: "0 - 24 tahun",
          Id: "0_24",
        },
        {
          Title: "25 - 34 tahun",
          Id: "25_34",
        },
        {
          Title: "35 - 44 tahun",
          Id: "35_44",
        },
        {
          Title: "45 - 54 tahun",
          Id: "45_54",
        },
        {
          Title: "55 tahun ++",
          Id: "55+",
        },
        {
          Title: "Women",
          Id: "women",
        },
      ],
    };
  },
  computed: {
    AgeGroupDisplay() {
      let vm = this;

      let newArray = vm.listUmur.filter(function (item) {
        return item.Id === vm.ageGroup;
      });

      if (vm.ageGroup !== "ALL") {
        return newArray[0].Title + " : ";
      } else {
        return "";
      }
    },
    Athletes() {
      if (this.Leaderboard === null) {
        return [];
      } else {
        return this.Leaderboard.Athletes;
      }
    },
    FilteredList() {
      let vm = this;

      if (vm.ageGroup === "ALL") {
        return this.Athletes;
      }

      return this.Athletes.filter((item) => {
        if (vm.ageGroup === "women") {
          return item.IsWomen;
        } else {
          return item.Class === vm.ageGroup;
        }
      });
    },
    LastUpdated() {
      if (this.Leaderboard === null) {
        return "";
      } else {
        let lastUpdate = this.Leaderboard.LastUpdated;
        var mmnt = moment(lastUpdate);

        return mmnt.fromNow();
      }
    },
    LastUpdatedDetail() {
      if (this.Leaderboard === null) {
        return "";
      } else {
        let dt = moment(this.Leaderboard.LastUpdated);
        if (dt.isSame(moment(), "day")) {
          return dt.format("HH:mm");
        } else {
          return dt.format("DD MMM YYYY") + " at " + dt.format("HH:mm");
        }
      }
    },
    ShowAge() {
      // if (
      //   this.date === "21113553_2021-10-12" ||
      //   this.date === "21113553_2021-10-19" ||
      //   this.date === "21113553_2021-10-05"
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
      return true;
    },
  },
  methods: {
    getData: function (id) {
      let vm = this;
      let todayId = new Date().toJSON().substr(0, 10);
      let timeStamp = "";
      vm.ageGroup = "ALL";
      if (id.indexOf(todayId) > -1) {
        timeStamp = "?t=" + new Date().getTime();
      }

      let fileName = id + ".json" + timeStamp;
      axios
        .get(
          "https://strava-leaderboard.s3.ap-southeast-1.amazonaws.com/" +
            fileName
        )
        .then((response) => (vm.Leaderboard = response.data));
    },
    onPrChange() {
      let labelTurnOn = "compactView OFF";
      if (this.compactView) {
        labelTurnOn = "compactView ON";
      }
      this.$gtag.event(labelTurnOn, {
        event_category: "compactView",
      });
    },
    onProfileClick(item) {
      this.$gtag.event(item.Name, {
        event_category: "profileClick",
      });
    },
    onActivityClick(item) {
      this.$gtag.event(item.Name, {
        event_category: "activityClick",
      });
    },
    onPrActivityClick(item) {
      this.$gtag.event(item.Name, {
        event_category: "prClick",
      });
    },
    scrollTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 50);
      }, 20);
    },

    onAgeChange() {},
  },
  filters: {
    relativeDateView: function (date) {
      let time = moment().format("HH:mm");
      date += " " + time;
      return moment(date, "YYYY-MM-DD HH:mm").fromNow();
    },
    useEmpty: function (imgUrl) {
      if (imgUrl === null)
        return "https://d3nn82uaxijpm6.cloudfront.net/assets/avatar/athlete/large-800a7033cc92b2a5548399e26b1ef42414dd1a9cb13b99454222d38d58fd28ef.png";
      else return imgUrl;
    },
  },
  mounted() {},
};
</script>